import { render, staticRenderFns } from "./StaffCard.vue?vue&type=template&id=fa5c1924&"
import script from "./StaffCard.vue?vue&type=script&lang=js&"
export * from "./StaffCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports